import { render, staticRenderFns } from "./CustomLogin.vue?vue&type=template&id=2c25766f&scoped=true"
import script from "./CustomLogin.vue?vue&type=script&lang=js"
export * from "./CustomLogin.vue?vue&type=script&lang=js"
import style0 from "./CustomLogin.vue?vue&type=style&index=0&id=2c25766f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25766f",
  null
  
)

export default component.exports